import angular from 'angular';
import APIV5 from '~/models/api';
import { createProgressWidget } from '~/pages/dashboard/models/widget';

export default class {
	/** @type {Knitiv.RootScope} */
	$rootScope;

	/* @ngInject */
	/**
	 * @param {angular.ITimeoutService} $timeout
	 * @param {Knitiv.RootScope} $rootScope
	 * @param $scope
	 */
	constructor($timeout, $rootScope, $scope) {
		this.loading = false;
		this.isOpen = true;
		this.isLoaded = false;

		/** @type {Dashboard.QueryCellContent | undefined} */
		this.dashboard = undefined;

		/** @type {any[]} */
		this.widgets = [];

		this.$timeout = $timeout;
		this.$rootScope = $rootScope;
		this.$scope = $scope;
	}

	expand() {
		this.isOpen = true;
	}

	retract() {
		this.isOpen = false;
	}

	widgetLength() {
		return this.widgets.length;
	}

	async loadDashboard() {
		this.loading = true;

		if (!this.dashboard?.kid) {
			return;
		}
		/**
		 * @type {any[]}
		 */
		const promises = [];

		/** @type {import('@knitiv/api-client-javascript').QueryBuilder<'order' | 'widget' | 'query' | 'type'>} */
		const widgetBuilder = APIV5.instance.createQueryBuilder();
		widgetBuilder
			.select(select => select
				.addColumn(column => column
					.as('widget')
					.withTarget('K_NODE;WIDGET'))
				.addColumn(columnBuilder => columnBuilder
					.as('type')
					.withTarget('K_NODE;WIDGETTYPE')
					.withPath(pathBuilder => pathBuilder
						.flowDown('K_NODE;WIDGETTYPE'),
					),
				)
				.addColumn(column => column
					.as('order')
					.withTarget('K_NODE;INTEGER')
					.withType('K_NODE;INTEGER')
					.withPath(path => path
						.flowDown('K_NODE;INTEGER', 'K_NODE;RANK')))
				.addColumn(column => column
					.as('query')
					.withTarget('K_NODE;KSYSQUERY')
					.withFormat('KATTR:QUERY')
					.withPath(path => path
						.flowDown('K_NODE;KSYSQUERY'))),
			)
			.from(from => from.addElement('K_NODE;WIDGET'))
			.where(whereBuilder => whereBuilder
				.addRule(ruleBuilder => ruleBuilder
					.equalKid('K_NODE;DASHBOARD', this.dashboard.kid)
					.withPath(pathBuilder => pathBuilder
						.flowUp('K_NODE;DASHBOARD'),
					),
				),
			);

		const response = await widgetBuilder.fetchAll(
			undefined,
			undefined,
			{ id: 'dashboard-block.load' },
		);

		const widgets = response.resolved().rows.map(row => {
			const order = row.order?.[0]?.name ?? 0;
			return ({
				widget: row.widget[0],
				order: (typeof order === 'string') ? (Number.parseInt(order, 10)) : order,
				query: row.query[0].kid,
				isLoading: false,
				/** @type {undefined | number} */
				queryResult: undefined,
				name: row.widget[0].name,
				type: row.type[0].kid,
				kid: row.widget[0].kid,
				error: undefined,
			});
		});

		for (const widget of Object.values(widgets)) {
			widget.isLoading = true;

			this.$timeout(() => {
				if (this.widgets?.[widget.kid]) {
					this.widgets[widget.kid].isLoading = true;
				}
			});

			promises.push(async () => {
				try {
					if (widget.query === 'NONE') {
						this.$timeout(() => {
							widget.queryResult = 0;
							widget.error = {
								icon: 'fa fa-exclamation-triangle',
								message: 'Erreur de paramétrage',
							};
							widget.isLoading = false;
						});
					}
					else if (widget.type === 'K_NODE;WDGT_PROGRESS') {
						const w = await createProgressWidget(widget.kid, {
							from: undefined,
						});

						this.$timeout(() => {
							widget.data = w.data;
							widget.percent = w.percent;
							widget.isLoading = false;
						});
					}
					else {
						const result = await APIV5.instance.queryRun({
							query_kid: widget.query,
							onlytotal: true,
						}, { id: 'dashboard-block.load-widget-query' });

						this.$timeout(() => {
							widget.queryResult = result.result.total;
							widget.isLoading = false;
						});
					}
				}
				catch (error) {
					console.error('e', error);
					this.$timeout(() => {
						widget.queryResult = 0;
						widget.isLoading = false;
						widget.error = {
							icon: 'fa fa-exclamation-triangle',
							message: 'home.blocks.dashboard.error.query-count',
						};
					});
				}
			});
		}

		this.$timeout(async () => {
			// execute
			await Promise.all(promises.map(x => x()));

			this.widgets = widgets;

			// console.log('this.widgets', this.widgets);

			this.loading = false;
			this.isLoaded = true;

			this.$rootScope.$emit('gridtsack.refresh-item', {
				widgetId: this.widgetId,
			});
		});
	}

	/**
	 * @param {boolean} state
	 */
	onToggle(state) {
		this.state = state;
		let count = 5;
		// eslint-disable-next-line angular/interval-service
		const interval = setInterval(() => {
			if (count <= 0) {
				clearInterval(interval);
			}
			this.$rootScope.$emit('gridtsack.refresh-item', {
				widgetId: this.widgetId,
			});
			count -= 1;
		}, 100);
	}

	async $onInit() {
		// if it's opened at start, load it
		if (this.isOpen === true) {
			this.loadDashboard();
		}

		// when isOpen changed
		this.$scope.$watch(() => this.isOpen, () => {
			// if it's now opened and not already loaded, load it
			if (this.isOpen === true && this.isLoaded === false) {
				this.loadDashboard();
			}
		});
	}
}
